<template>
  <section v-if="bgLayout === 'center'" class="mobile-style1 center-login-form">
    <p class="center-login-form-title">
      <Icon size="44" class="icon" type="md-arrow-dropleft" :style="{ 'color': settingData.inputBorderColor }" @click="$emit('on-back'), doReset()"/>
      <span :style="{ 'color': settingData.fontColor }">{{ type === 'forgetPassword' ? $t('loginPage.wjmm') : $t('loginPage.dlsjyz') }}</span>
    </p>
    <div class="center-login-form-input" v-if="type === 'forgetPassword'" :style="{ 'border-color': settingData.inputBorderColor }">
      <span class="input-icon">
        <svg class="icon" aria-hidden="true" :style="{ 'color': settingData.inputBorderColor }">
          <use xlink:href="#icon-kejiyonghu"></use>
        </svg>
      </span>
      <input @blur="onBlur" v-model="mobileFormValidate.userName" class="input-self" :placeholder="$t('loginPage.yhmygbh')" type="text" :style="{ 'color': settingData.fontColor }"/>
    </div>
    <div class="center-login-form-input" v-if="type === 'forgetPassword'" :style="{ 'border-color': settingData.inputBorderColor }">
      <span class="input-icon">
        <svg class="icon" aria-hidden="true" :style="{ 'color': settingData.inputBorderColor }">
          <use xlink:href="#icon-kejishoujihao"></use>
        </svg>
      </span>
      <Select :placeholder="$t('loginPage.sjhm')" v-model="mobileFormValidate.phoneNumber" class="input-self input-self-select" :style="{ 'color': settingData.fontColor }">
        <Option :value="item.mobile" v-for="(item, index) in phoneList" :key="index">{{ item.mobile }}</Option>
      </Select>
    </div>

    <div class="center-login-form-input" v-if="type === 'mobile'" :style="{ 'border-color': settingData.inputBorderColor }">
      <span class="input-icon">
        <svg class="icon" aria-hidden="true" :style="{ 'color': settingData.inputBorderColor }">
          <use xlink:href="#icon-kejishoujihao"></use>
        </svg>
      </span>
      <Select :placeholder="$t('loginPage.sjhm')" v-model="mobileFormValidate.phoneNumber" class="input-self input-self-select" :style="{ 'color': settingData.fontColor }">
        <Option :value="item.mobile" v-for="(item, index) in phoneList" :key="index">{{ item.mobile }}</Option>
      </Select>
    </div>
    <div class="center-login-form-input" :style="{ 'border-color': settingData.inputBorderColor }">
      <span class="input-icon">
        <svg class="icon" aria-hidden="true" :style="{ 'color': settingData.inputBorderColor }">
          <use xlink:href="#icon-kejiyanzhengma"></use>
        </svg>
      </span>
      <input v-model="mobileFormValidate.verificationCode" class="input-self" :placeholder="$t('loginPage.dxyzm')" :style="{ 'color': settingData.fontColor }"/>
      <span class="verify-code" @click="doGetLoginVerCode" :style="{ 'color': settingData.buttonColor }">
        <span v-show="verifyCodeShow">{{ $t('loginPage.hqyzm') }}</span>
        <span v-show="!verifyCodeShow">{{`${waitTime}s${$t('loginPage.hcxhq')}`}}</span>
      </span>
    </div>
    <button @click="doVerifyLogin" class="center-login-button" :style="{ 'background-color': settingData.buttonColor }">{{ type === 'forgetPassword' ? $t('loginPage.xyb') : $t('qd') }}</button>
  </section>
  <!-- <section v-if="bgLayout === 'center'" class="mobile-style2 center-login-form">
    <p class="center-login-form-title">
      <Icon size="44" class="icon" type="md-arrow-dropleft" :style="{ 'color': settingData.inputBorderColor }" @click="$emit('on-back'), doReset()"/>
      <span :style="{ 'color': settingData.fontColor }">{{ type === 'forgetPassword' ? $t('loginPage.wjmm') : $t('loginPage.dlsjyz') }}</span>
    </p>
    <div class="center-login-form-input" v-if="type === 'forgetPassword'" :style="{ 'background-color': settingData.inputBgColor, 'border-color': settingData.inputBorderColor }">
      <span class="input-icon">
        <svg class="icon" aria-hidden="true" :style="{ 'color': settingData.inputBorderColor }">
          <use xlink:href="#icon-kejiyonghu"></use>
        </svg>
      </span>
      <input @blur="onBlur" v-model="mobileFormValidate.userName" class="input-self" :placeholder="$t('loginPage.yhmygbh')" type="text" :style="{ 'color': settingData.fontColor }"/>
    </div>
    <div class="center-login-form-input" v-if="type === 'forgetPassword'" :style="{ 'background-color': settingData.inputBgColor, 'border-color': settingData.inputBorderColor }">
      <span class="input-icon">
        <svg class="icon" aria-hidden="true" :style="{ 'color': settingData.inputBorderColor }">
          <use xlink:href="#icon-kejishoujihao"></use>
        </svg>
      </span>
      <Select :placeholder="$t('loginPage.sjhm')" v-model="mobileFormValidate.phoneNumber" class="input-self input-self-select" :style="{ 'color': settingData.fontColor }">
        <Option :value="item.mobile" v-for="(item, index) in phoneList" :key="index">{{ item.mobile }}</Option>
      </Select>
    </div>

    <div class="center-login-form-input" v-if="type === 'mobile'" :style="{ 'background-color': settingData.inputBgColor, 'border-color': settingData.inputBorderColor }">
      <span class="input-icon">
        <svg class="icon" aria-hidden="true" :style="{ 'color': settingData.inputBorderColor }">
          <use xlink:href="#icon-kejishoujihao"></use>
        </svg>
      </span>
      <Select :placeholder="$t('loginPage.sjhm')" v-model="mobileFormValidate.phoneNumber" class="input-self input-self-select" :style="{ 'color': settingData.fontColor }">
        <Option :value="item.mobile" v-for="(item, index) in phoneList" :key="index">{{ item.mobile }}</Option>
      </Select>
    </div>
    <div class="center-login-form-input" :style="{ 'background-color': settingData.inputBgColor, 'border-color': settingData.inputBorderColor }">
      <span class="input-icon">
        <svg class="icon" aria-hidden="true" :style="{ 'color': settingData.inputBorderColor }">
          <use xlink:href="#icon-kejiyanzhengma"></use>
        </svg>
      </span>
      <input v-model="mobileFormValidate.verificationCode" class="input-self input-self-code" :placeholder="$t('loginPage.dxyzm')" :style="{ 'color': settingData.fontColor }"/>
      <span class="verify-code" @click="doGetLoginVerCode" :style="{ 'color': settingData.buttonColor }">
        <span v-show="verifyCodeShow">{{ $t('loginPage.hqyzm') }}</span>
        <span v-show="!verifyCodeShow">{{`${waitTime}s${$t('loginPage.hcxhq')}`}}</span>
      </span>
    </div>
    <button @click="doVerifyLogin" class="center-login-button" :style="{ 'background-color': settingData.buttonColor }">{{ type === 'forgetPassword' ? $t('loginPage.xyb') : $t('qd') }}</button>
  </section> -->
  <section v-else class="right-login-form">
    <p class="right-login-form-title">
      <Icon class="icon" type="md-arrow-back" :style="{ 'color': settingData.fontColor }" @click="$emit('on-back'), doReset()"/>
      <span :style="{ 'color': settingData.fontColor }">{{ type === 'forgetPassword' ? $t('loginPage.wjmm') : $t('loginPage.dlsjyz') }}</span>
    </p>
    <div class="right-login-form-input" v-if="type === 'forgetPassword'" :style="{ 'background-color': settingData.inputBgColor, 'border-color': settingData.inputBorderColor }">
      <span class="input-icon">
        <svg class="icon" aria-hidden="true" :style="{ 'color': settingData.inputBorderColor }">
          <use xlink:href="#icon-yonghu"></use>
        </svg>
      </span>
      <input @blur="onBlur" v-model="mobileFormValidate.userName" class="input-self" :placeholder="$t('loginPage.yhmygbh')" type="text" :style="{ 'color': settingData.fontColor }"/>
    </div>
    <div class="right-login-form-input" v-if="type === 'forgetPassword'" :style="{ 'background-color': settingData.inputBgColor, 'border-color': settingData.inputBorderColor }">
      <span class="input-icon">
        <svg class="icon" aria-hidden="true" :style="{ 'color': settingData.inputBorderColor }">
          <use xlink:href="#icon-dianhua"></use>
        </svg>
      </span>
      <Select :placeholder="$t('loginPage.sjhm')" v-model="mobileFormValidate.phoneNumber" class="input-self input-self-select" :style="{ 'color': settingData.fontColor }">
        <Option :value="item.mobile" v-for="(item, index) in phoneList" :key="index">{{ item.mobile }}</Option>
      </Select>
    </div>

    <div class="right-login-form-input" v-if="type === 'mobile'" :style="{ 'background-color': settingData.inputBgColor, 'border-color': settingData.inputBorderColor }">
      <!-- <span class="input-icon">
        <svg class="icon" aria-hidden="true" :style="{ 'color': settingData.inputBorderColor }">
          <use xlink:href="#icon-dianhua"></use>
        </svg>
      </span>
      <Dropdown trigger="click" class="input-dropdown-short" :style="{ 'color': settingData.fontColor }">
        <span>
          +86
          <Icon type="ios-arrow-down"></Icon>
        </span>
        <DropdownMenu slot="list">
          <DropdownItem>+86</DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <input v-model="mobileFormValidate.phoneNumber" class="input-self" :placeholder="$t('loginPage.sjhm')" type="text" :style="{ 'color': settingData.fontColor }"/> -->
      <span class="input-icon">
        <svg class="icon" aria-hidden="true" :style="{ 'color': settingData.inputBorderColor }">
          <use xlink:href="#icon-kejishoujihao"></use>
        </svg>
      </span>
      <Select :placeholder="$t('loginPage.sjhm')" v-model="mobileFormValidate.phoneNumber" class="input-self input-self-select" :style="{ 'color': settingData.fontColor }">
        <Option :value="item.mobile" v-for="(item, index) in phoneList" :key="index">{{ item.mobile }}</Option>
      </Select>
    </div>
    <div class="right-login-form-input" :style="{ 'background-color': settingData.inputBgColor, 'border-color': settingData.inputBorderColor }">
      <span class="input-icon">
        <svg class="icon" aria-hidden="true" :style="{ 'color': settingData.inputBorderColor }">
          <use xlink:href="#icon-yanzhengma"></use>
        </svg>
      </span>
      <input v-model="mobileFormValidate.verificationCode" class="input-self" :placeholder="$t('loginPage.dxyzm')" :style="{ 'color': settingData.fontColor }"/>
      <span class="verify-code" @click="doGetLoginVerCode" :style="{ 'color': settingData.buttonColor }">
        <span v-show="verifyCodeShow">{{ $t('loginPage.hqyzm') }}</span>
        <span v-show="!verifyCodeShow">{{`${waitTime}s${$t('loginPage.hcxhq')}`}}</span>
      </span>
    </div>
    <button @click="doVerifyLogin" class="right-login-button" :style="{ 'background-color': settingData.buttonColor }">{{ type === 'forgetPassword' ? $t('loginPage.xyb') : $t('qd') }}</button>
  </section>
</template>

<script>
import { session, cookie } from '@/libs/location'
export default {
  name: 'mobileVerify',
  props: {
    // forgetPassword 忘记密码  mobile 手机验证码
    type: {
      type: String,
      default: 'forgetPassword'
    },
    userInfo: {
      type: Object,
      default: () => {}
    },
    loginFormValidate: {
      type: Object,
      default: () => {}
    },
    // 忘记密码页面返回信息
    forgetData: {
      type: Object,
      default: () => {}
    },
    // mobileList
    mobileList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      bgLayout: 'center',
      verifyCodeShow: true,
      timer: null,
      waitTime: 60,
      phoneList: [],
      mobileFormValidate: {
        phoneNumber: '',
        userName: ''
      }
    }
  },
  computed: {
    settingData () {
      return this.$store.state.settingData
    }
  },
  watch: {
    mobileList: {
      handler (val) {
        this.phoneList = val
        this.mobileFormValidate.phoneNumber = val[0] ? val[0].mobile : ''
      },
      immediate: true
    },
    type: {
      handler (val) {
        if (val === 'forgetPassword' && this.loginFormValidate.userName) {
          this.mobileFormValidate.userName = this.loginFormValidate.userName
          this.onBlur()
        }
      },
      immediate: true
    },
    'mobileFormValidate.userName' (val) {
      this.phoneList = []
      this.mobileFormValidate.phoneNumber = ''
      this.mobileFormValidate.redisKey = ''
      this.mobileFormValidate.verificationCode = ''
    }
  },
  created () {
    this.bgLayout = this.$store.state.settingData.bgLayout
    if (this.forgetData) {
      this.mobileFormValidate.phoneNumber = this.forgetData.mobile
      this.mobileFormValidate.verificationCode = this.forgetData.verCode
      this.mobileFormValidate.redisKey = this.forgetData.redisKey
    }
  },
  methods: {
    // 选择手机号码
    onClickDropdown (name) {
      this.mobileFormValidate.phoneNumber = name
    },
    // 根据用户名获取手机号
    onBlur () {
      if (this.mobileFormValidate.userName) {
        this.$request.post('/sso/userMobile/findUserMobileList', { userName: this.mobileFormValidate.userName }).then(res => {
          const { code, data } = res.data
          if (code === 'OK') {
            this.phoneList = data
            this.mobileFormValidate.phoneNumber = data[0] ? data[0].mobile : ''
          }
        })
      } else {
        this.$Message.warning(this.$t('loginPage.yhmbnwk'))
      }
    },
    // 获取验证码
    doGetLoginVerCode () {
      // !/^1[3456789]\d{9}$/.test(this.mobileFormValidate.phoneNumber)
      if (!this.verifyCodeShow) {
        return false
      }
      if (!this.mobileFormValidate.phoneNumber) {
        this.$Message.warning(this.$t('loginPage.qxsrzqdsjhm'))
      } else {
        let req = {
          mobile: this.mobileFormValidate.phoneNumber,
          userCode: this.mobileFormValidate.userName
        }
        this.$request.post('/sso/login/getVerificationCode', req).then(res => {
          let { code, data } = res.data
          if (code === 'OK') {
            const TIME_COUNT = 60 // 默认倒计时秒数
            if (!this.timer) {
              this.waitTime = TIME_COUNT
              this.verifyCodeShow = false
              this.timer = setInterval(() => {
                if (this.waitTime > 0 && this.waitTime <= TIME_COUNT) {
                  this.waitTime--
                } else {
                  this.verifyCodeShow = true
                  clearInterval(this.timer) // 清空定时器
                  this.timer = null
                }
              }, 1000)
            }
            this.mobileFormValidate.redisKey = data
            this.$Message.success(this.$t('loginPage.fscg'))
          }
        })
      }
    },
    // 验证登录
    doVerifyLogin () {
      if (this.type === 'mobile') {
        // !/^1[3456789]\d{9}$/.test(this.mobileFormValidate.phoneNumber)
        if (!this.mobileFormValidate.phoneNumber) {
          this.$Message.warning(this.$t('loginPage.qxsrzqdsjhm'))
          return false
        } else if (!this.mobileFormValidate.verificationCode) {
          this.$Message.warning(this.$t('loginPage.qsrdxyzm'))
          return false
        } else if (!this.mobileFormValidate.redisKey) {
          this.$Message.warning(this.$t('loginPage.qhqyzm'))
          return false
        }
        let req = {
          id: JSON.parse(session.getItem('userInfo')).id,
          verCode: this.mobileFormValidate.verificationCode,
          redisKey: this.mobileFormValidate.redisKey,
          mobile: this.mobileFormValidate.phoneNumber
        }
        this.$request.post('/sso/login/checkMobileCode', req).then(res => {
          const { code, data } = res.data
          if (code === 'OK') {
            switch (data.nextStep) {
              case 'index':
                // 设置语言和皮肤
                this.$i18n.locale = data.languageSign
                this.$store.dispatch('doChangeSkin', data.skinColor)

                // session.setObject(data.sessionId)
                session.setItem('userInfo', JSON.stringify(data))
                let car = ['dlcd.dolinkhub.com']
                if (car.indexOf(window.location.host) !== -1) {
                  cookie.setCookie(`token${window.document.location.href.split('/')[3]}`, data.sessionId)
                } else {
                  cookie.setCookie(`token`, data.sessionId)
                }
                cookie.setCookie('userInfo', JSON.stringify(data))
                this.$router.push({ name: 'home' })

                this.$Message.success(this.$t('czcg'))
                break

              case 'updatePwd':
                this.$emit('on-update-pwd')
                break

              default:
                this.$Modal.warning({
                  title: this.$t('wxts'),
                  content: data.message
                })
                break
            }
          }
        })

        // let req = {
        //   userCode: this.loginFormValidate.userName,
        //   password: this.loginFormValidate.userPassword,
        //   mobile: this.mobileFormValidate.phoneNumber,
        //   verCode: this.mobileFormValidate.verificationCode,
        //   redisKey: this.mobileFormValidate.redisKey
        // }
        // this.$request.post('/sso/login/userLogin', req).then(res => {
        //   const { code, data } = res.data
        //   if (code === 'OK') {
        //     session.setObject(data.sessionId)
        //     session.setItem('userInfo', JSON.stringify(data))
        //     cookie.setCookie('token', data.sessionId)
        //     cookie.setCookie('userInfo', JSON.stringify(data))
        //     this.$router.push({ name: 'home_old' })
        //     this.$Message.success(this.$t('czcg'))
        //     this.doReset()
        //     if (data.remindedMessage) {
        //       this.$Modal.warning({
        //         title: this.$t('wxts'),
        //         content: data.remindedMessage
        //       })
        //     }
        //   }
        // })
      } else if (this.type === 'forgetPassword') {
        // 忘记密码
        if (!this.mobileFormValidate.userName) {
          this.$Message.warning(this.$t('loginPage.qsryhm'))
          return false
        } else if (!this.mobileFormValidate.phoneNumber) {
          this.$Message.warning(this.$t('loginPage.qxzsjhm'))
          return false
        } else if (!this.mobileFormValidate.verificationCode) {
          this.$Message.warning(this.$t('loginPage.qsrdxyzm'))
          return false
        } else if (!this.mobileFormValidate.redisKey) {
          this.$Message.warning(this.$t('loginPage.qhqyzm'))
          return false
        }
        let req = {
          userName: this.mobileFormValidate.userName,
          verCode: this.mobileFormValidate.verificationCode,
          redisKey: this.mobileFormValidate.redisKey
        }
        this.$request.post('/sso/login/checkMobileCodeForForget', req).then(res => {
          const { code, data } = res.data
          if (code === 'OK') {
            if (data.nextStep === 'remind') {
              this.$Modal.warning({
                title: this.$t('wxts'),
                content: data.message
              })
            } else {
              this.$emit('on-forget-password', { id: data.id })
            }
          }
        })
      }
    },
    // 重置表单
    doReset () {
      this.verifyCodeShow = true
      this.timer = null
      this.waitTime = 60
      this.mobileFormValidate = {
        phoneNumber: '',
        userName: ''
      }
    }
  }
}
</script>

<style lang="less">
.mobile-style1 {
  .input-dropdown {
    flex: 1;
    font-size: 20px;
    &-short {
      flex: 0 0 80px;
    }
    .plac {
      color: #7F7F7F;
    }
    .ivu-dropdown-rel {
      display: block;
      .ivu-icon {
        float: right;
      }
    }
  }
  .verify-code {
    display: inline-block;
    flex: 1;
    font-size: 18px;
    color: #00A8FE;
    text-align: right;
    span:first-child {
      cursor: pointer;
    }
  }
}
.input-self-select {
  .ivu-select-selection {
    background: transparent !important;
    border: 0px !important;
    outline: none !important;
    box-shadow: none !important;
  }
  .ivu-select-placeholder {
    font-size: 18px !important;
    color: #757575 !important;
    padding-left: 0 !important;
    text-align: left !important;
  }
  .ivu-select-selected-value {
    font-size: 18px !important;
    padding-left: 0 !important;
    text-align: left !important;
  }
}
.mobile-style2 {
  .input-dropdown {
    flex: 1;
    font-size: 20px;
    &-short {
      flex: 0 0 80px;
    }
    .plac {
      color: #7F7F7F;
    }
    .ivu-dropdown-rel {
      display: block;
      .ivu-icon {
        float: right;
      }
    }
  }
  .verify-code {
    display: inline-block;
    position: absolute;
    right: 12px;
    font-size: 14px;
    color: #00A8FE;
    text-align: right;
    span:first-child {
      cursor: pointer;
    }
  }
  .input-self-code {
    max-width: 120px;
  }
  .input-self-select {
    .ivu-select-selection {
      background: transparent !important;
      border: 0px !important;
      outline: none !important;
      box-shadow: none !important;
    }
    .ivu-select-placeholder {
      font-size: 18px !important;
      color: #757575 !important;
      padding-left: 0 !important;
      text-align: left !important;
    }
    .ivu-select-selected-value {
      font-size: 18px !important;
      padding-left: 0 !important;
      text-align: left !important;
    }
  }
}
.right-login-form {
  .ivu-select-placeholder {
    font-size: 18px !important;
    color: #999 !important;
    padding-left: 0 !important;
    text-align: left !important;
  }
  .ivu-select-selected-value {
    font-size: 18px !important;
    padding-left: 0 !important;
    text-align: left !important;
  }
  .verify-code {
    font-size: 18px;
    span:first-child {
      cursor: pointer;
    }
  }
}
</style>
